import {Component, Input} from '@angular/core';
import {FormGroup} from "@angular/forms";

@Component({
  selector: 'form-field-relation',
  templateUrl: 'form-field-relation.component.html',
  styleUrls: ['form-field-relation.component.scss']
})
export class FormFieldRelationComponent {
  @Input() field!: any;
  @Input() formGroup!: FormGroup;

  constructor() {
  }

  ngOnInit() {
  }
}
